import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Badge, Col, Row, Tabs } from "antd";
import Text from "../../../../components/Text/Text";
import color from "../../../../resource/color";
import { icon } from "../../../../resource";
import TablePagination from "../../../../components/Table/TablePagination";
import { dateFormatter, numberFormatter } from "../../../../utility/Formatter";
import Button from "../../../../components/Button/Button";
import ModalCancelCRMPoint from "../../../../components/Modal/ModalCancelCRMPoint";
import { OrderProductEntity, PointDetailEntity } from "../../../../entities/PointApproveEntity";
import {
  cancelOrderPoint,
  getPointDetail,
  updateCheckOrderPoint,
} from "../../../../datasource/OrderPointDatasource";
import SumProducts from "../../../../components/ApprovePoint/SumTotalOrderProduct";
import ModalSaleCheck from "../../../../components/Modal/ModalSaleCheck";
import DetailSDL from "./ContentDetail/DetailSDL";
import DetailDL from "./ContentDetail/DetailDL";

export const Texts = styled.div`
  font-family: "Sarabun";
  font-size: 16px;
  color: ${color.Text1};
  font-weight: 400;
  word-break: break-word;
  max-width: 100%;
  white-space: normal;
`;

const DetailContainer = styled.div`
  margin-top: 22px;
`;

const DetailBox = styled.div`
  background-color: ${color.background1};
  border-radius: 10px;
  padding: 24px;
  margin: 22px 0px 22px 0px;
  border: 0.3px solid #e5eaee;
`;

interface Props {
  data: PointDetailEntity;
  newFetch: () => void;
}

function DetailTab({ data, newFetch }: Props) {
  const [showModal, setShowModal] = useState(false);
  const orderPointId = window.location.pathname.split("/")[3];
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [programData, setProgramData] = useState<OrderProductEntity[]>();
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [tabKeyCampaign, setTabKeyCampaign] = useState<string>("true");
  const [modalIsCheck, setModalIsCheck] = useState(false);
  const lastHistoryOrderPoint = data.historyOrderPoint.slice(-1)[0];
  const statusAfter = lastHistoryOrderPoint?.statusAfter;
  const isType =
    JSON.parse(localStorage.getItem("approvePointListParams") || "{}").activeTabKey || "DEALER";

  useEffect(() => {
    if (data.orderProduct) {
      setProgramData(data.orderProduct);
      setActiveButton(data.campaigns.length > 0 ? data.campaigns[0].campaignId : null);
    }
  }, [data.orderProduct]);

  const handlePrograms = async (id: string) => {
    setLoading(true);
    setActiveButton(id);
    try {
      const params = {
        orderPointId: orderPointId,
        campaignId: id,
      };
      const res = await getPointDetail(params);
      setProgramData(res.orderProduct || []);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching program details:", error);
    } finally {
      setLoading(false);
    }
  };

  const groupProducts = (products: OrderProductEntity[]) => {
    return products.reduce((acc: any, item) => {
      const existing = acc.find((i: OrderProductEntity) => i.unitName === item.unitName);
      if (existing) {
        existing.amount += item.amount;
      } else {
        acc.push({
          unitName: item.unitName,
          amount: item.amount,
        });
      }
      return acc;
    }, []);
  };
  const groupedOrderProduct = data.orderProduct.length > 0 ? groupProducts(programData || []) : [];
  const groupedOrderProductWithoutProduct =
    data.orderProductWithOutCampaign.length > 0
      ? groupProducts(data.orderProductWithOutCampaign)
      : [];

  const grouped =
    tabKeyCampaign === "true" ? groupedOrderProduct : groupedOrderProductWithoutProduct;

  const onChange = (key) => {
    setTabKeyCampaign(key);
    if (key === "true") {
      setProgramData(data.orderProduct);
    } else {
      setProgramData(data.orderProductWithOutCampaign);
    }
  };
  const tabsItems = [
    {
      label: <Text fontSize={14}>เข้าร่วม {`(${data.orderProduct.length || 0})`}</Text>,
      key: "true",
    },
    {
      label: (
        <Text fontSize={14}>ไม่เข้าร่วม {`(${data.orderProductWithOutCampaign.length || 0})`}</Text>
      ),
      key: "false",
    },
  ];

  const columns: any[] = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={row.image || icon.emptyProduct}
                style={{ width: "50px", height: "50px", objectFit: "cover", marginRight: "10px" }}
              />
              <div>
                <Texts>{value}</Texts>
                <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                  {row.productCommonName}
                </Text>
                {tabKeyCampaign === "true" && !row.isFreebie && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={icon.rating}
                      style={{ width: "14px", height: "14px", marginRight: "4px" }}
                    />
                    <Texts>
                      {numberFormatter(row.programPoints) || 0} แต้ม{row.saleUomTh ? "/" : ""}
                      {row.saleUomTh}
                    </Texts>
                  </div>
                )}
              </div>
            </div>
          ),
        };
      },
    },
    {
      title: "ขนาด",
      dataIndex: "saleUom",
      key: "saleUom",
      width: "16%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts>{value}</Texts>
            </>
          ),
        };
      },
    },
    {
      title: isType === "SUB_DEALER" ? "ปริมาณกระสอบ" : "ปริมาณที่สั่งซื้อ",
      dataIndex: "amount",
      key: "amount",
      width: "16%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts>{numberFormatter(value, 0)}</Texts>
              <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                {row.unitName}
              </Text>
            </>
          ),
        };
      },
    },
    isType === "SUB_DEALER"
      ? {
          title: "ปริมาณตัน",
          dataIndex: "quantity",
          key: "quantity",
          width: "16%",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <>
                  <Texts>{numberFormatter(value, 2)}</Texts>
                  <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                    {row.saleUomTh || "ตัน"}
                  </Text>
                </>
              ),
            };
          },
        }
      : {},
    tabKeyCampaign === "true"
      ? {
          title: "แต้มที่ได้รับ",
          dataIndex: "point",
          key: "point",
          width: "16%",
          sorter: (a, b) => a.point - b.point,
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <>
                  {row.isFreebie && (
                    <Badge.Ribbon text='ของแถม' placement='end' color={color.error} />
                  )}
                  <Texts>{row.isFreebie ? "-" : numberFormatter(value, 2)}</Texts>
                  <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                    แต้ม
                  </Text>
                </>
              ),
            };
          },
        }
      : {},
  ];

  return (
    <DetailContainer>
      <Text fontSize={16} fontWeight={700}>
        รายละเอียด
      </Text>

      <DetailBox>
        {isType === "DEALER" ? (
          <DetailDL data={data} />
        ) : (
          <DetailSDL data={data} grouped={grouped} modalIsCheck={() => setModalIsCheck(true)} />
        )}
      </DetailBox>

      <Text fontSize={16} fontWeight={700}>
        สินค้าและแคมเปญที่เข้าร่วม
      </Text>
      <div style={{ margin: "18px 0px 0px 0px" }}>
        <Tabs
          type='card'
          items={tabsItems}
          onChange={(key: string) => {
            onChange(key);
          }}
          defaultValue={"true"}
        />
      </div>

      {tabKeyCampaign === "true" && (
        <div style={{ display: "flex", padding: "10px 0px", gap: "10px" }}>
          {data.campaigns.map((item, index) => (
            <Button
              key={item.campaignId}
              typeButton={activeButton === item.campaignId ? "navy-blue" : "primary-light"}
              title={item.campaignName}
              style={{
                width: "max-content",
              }}
              onClick={() => handlePrograms(item.campaignId)}
            />
          ))}
        </div>
      )}

      <TablePagination
        locale={{
          emptyText: (
            <div
              style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                minHeight: 400,
              }}
            >
              <img
                src={icon.emptyHistoryPoint}
                style={{
                  width: 80,
                  height: 90,
                }}
                alt='empty_table'
              />
              <Text fontFamily='Sarabun' fontSize={14} fontWeight={400}>
                ไม่มีสินค้าที่{tabKeyCampaign === "true" ? "เข้าร่วม" : "ไม่เข้าร่วม"}
              </Text>
            </div>
          ),
        }}
        columns={columns}
        isLoading={loading}
        data={(programData || []).map((item: any, index: number) => {
          return {
            ...item,
            id: index + 1,
          };
        })}
        scroll={{ x: "max-content" }}
      />
      {tabKeyCampaign === "true" ? (
        <>
          {data.orderProduct.length > 0 && (
            <SumProducts
              products={programData || []}
              grouped={grouped}
              tabKeyCampaign={tabKeyCampaign}
              statusAfter={statusAfter}
              historyOrderPoint={data.historyOrderPoint}
            />
          )}
        </>
      ) : (
        <>
          {data.orderProductWithOutCampaign.length > 0 && (
            <SumProducts
              products={data.orderProductWithOutCampaign}
              grouped={grouped}
              tabKeyCampaign={tabKeyCampaign}
              statusAfter={statusAfter}
              historyOrderPoint={data.historyOrderPoint}
            />
          )}
        </>
      )}
      {data.status === "CANCEL" && isType === "SUB_DEALER" ? (
        <>
          <Text fontSize={16} fontWeight={700}>
            หมายเหตุการยกเลิก
          </Text>
          <DetailBox>
            <Texts>{data.reason || "-"}</Texts>
          </DetailBox>
        </>
      ) : (
        <>
          {data.subDealerName && data.status !== "CANCEL" && (
            <Button
              typeButton='danger'
              title='ยกเลิกเอกสาร'
              style={{ width: 143 }}
              onClick={() => setShowModal(true)}
            />
          )}
        </>
      )}

      <ModalCancelCRMPoint
        visible={showModal}
        onCancel={() => setShowModal(false)}
        callBack={async (value) => {
          if (value) {
            const params = {
              orderPointId: orderPointId,
              userType: userProfile?.role,
              reason: value.reason,
              updateBy: `${userProfile.firstname} ${userProfile.lastname}`,
            };
            try {
              const res = await cancelOrderPoint(params);
              if (res.success) {
                newFetch();
                console.log("Cancel order point successful:", res);
              }
            } catch (error) {
              console.error("Error canceling order point:", error);
            } finally {
              setShowModal(false);
            }
          }
        }}
      />

      <ModalSaleCheck
        isCheck={data.isChecked}
        visible={modalIsCheck}
        onCancel={() => setModalIsCheck(false)}
        handleSubmit={async () => {
          try {
            const res = await updateCheckOrderPoint(
              orderPointId,
              data.isChecked ? false : true,
              `${userProfile.firstname} ${userProfile.lastname}`,
            );
            if (res.success) {
              newFetch();
            }
          } catch (error) {
            console.error("Error sale checked:", error);
          } finally {
            setModalIsCheck(false);
          }
        }}
      />
    </DetailContainer>
  );
}

export default DetailTab;
